<template>
  <el-dialog
    title="平台资料额度"
    :visible.sync="internalVisible"
    width="640px"
    class="quota-dialog"
  >
    <div class="quota-metrics">
      <div class="metric-item">
        <div class="label">总平台资料数</div>
        <div class="value">{{ total }}</div>
      </div>
      <div class="metric-item metric-item--used">
        <div class="label">你已使用</div>
        <div class="value">{{ used }}</div>
      </div>
      <div class="metric-item metric-item--remain">
        <div class="label">剩余可用</div>
        <div class="value">{{ remain }}</div>
      </div>
    </div>

    <div class="choose-title">您可以选择：</div>

    <div class="quota-actions">
      <div class="action-card">
        <div class="info">
          <img class="icon" :src="rocketIcon" alt="订购" />
          <div class="texts">
            <div class="title">订购平台资料加量包</div>
            <div class="desc">如果您的商品多/上新快，推荐直接订购加量包，提升平台资料额度</div>
          </div>
        </div>
        <el-button type="primary" @click="handleSubscribe">去订购</el-button>
      </div>

      <div class="action-card">
        <div class="info">
          <img class="icon" :src="cleanIcon" alt="清理" />
          <div class="texts">
            <div class="title">清理无效商品</div>
            <div class="desc">可优先清理0销量/低销量，以及重复的商品，腾出空间</div>
          </div>
        </div>
        <div class="btns">
          <el-button @click="handleCleanDuplicate">清理重复商品</el-button>
          <!-- <el-button type="primary" @click="handleCleanLowSales">清理低销量商品</el-button> -->
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import rocketIcon from '@/assets/images/rocket.png'
import cleanIcon from '@/assets/images/clean.png'
export default {
  name: 'QuotaDialog',
  props: {
    visible: { type: Boolean, default: false },
    total: { type: [Number, String], default: 0 },
    used: { type: [Number, String], default: 0 },
  },
  data() {
    return { internalVisible: this.visible, rocketIcon, cleanIcon };
  },
  watch: {
    visible(val) { this.internalVisible = val; },
    internalVisible(val) { this.$emit('update:visible', val); },
  },
  computed: {
    remain() {
      // 当总平台资料数为“无上限”时，剩余可用也展示“无上限”，不做计算
      if (this.total === '无上限') {
        return '无上限';
      }
      const t = Number(this.total) || 0;
      const u = Number(this.used) || 0;
      const r = t - u;
      return r < 0 ? 0 : r;
    },
  },
  methods: {
    handleSubscribe() { this.$emit('subscribe'); },
    handleCleanDuplicate() { this.$emit('clean-duplicate'); },
    handleCleanLowSales() { this.$emit('clean-low-sales'); },
  },
};
</script>

<style lang="scss" scoped>
.quota-dialog ::v-deep .el-dialog__body {
  padding-top: 10px;
}
.quota-metrics {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fff;
}
.metric-item { flex: 1; text-align: center; }
.metric-item .label { color: #666; margin-bottom: 6px; }
.metric-item .value { font-size: 20px; font-weight: 600; }
.metric-item--used .value { color: #ff4d4f; }
.metric-item--remain .value { color: #67c23a; }
.choose-title { font-weight: 600; margin-bottom: 8px; }
.quota-actions .action-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 16px;
  background: #fff;
  margin-bottom: 12px;
}
.action-card .info { display: flex; align-items: flex-start; }
.action-card .icon { width: 24px; height: 24px; margin-right: 12px; object-fit: contain; display: inline-block; }
.action-card .texts .title { font-weight: 600; margin-bottom: 4px; }
.action-card .texts .desc { color: #999; font-size: 12px; }
.action-card .btns .el-button + .el-button { margin-left: 8px; }
</style>